import { render, staticRenderFns } from "./custom-picture.vue?vue&type=template&id=49c9f8d9&scoped=true&"
import script from "./custom-picture.vue?vue&type=script&lang=js&"
export * from "./custom-picture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c9f8d9",
  null
  
)

export default component.exports